import classNames from 'classnames';

import { getStackIconByName } from '../../../../helpers/stackIcons';

interface ISingleStackTagProps {
  stack: string;
  className?: string;
}

const DefaultStackIcon: React.FC = () => {
  return (
    <div className="flex w-6 h-6 overflow-hidden rounded-[4px]">
      <div className="w-1/3 h-full bg-grey-100"></div>
      <div className="w-1/3 h-full bg-grey-200"></div>
      <div className="w-1/3 h-full bg-grey-500"></div>
    </div>
  );
};

const SingleStackTag: React.FC<ISingleStackTagProps> = ({
  stack,
  className = '',
}) => {
  return (
    <div
      className={classNames(
        'bg-grey-50 py-1 px-2 flex shrink-0 items-center gap-2 rounded-md font-medium text-regular text-grey-700 whitespace-nowrap',
        className,
      )}
    >
      <div className="flex items-center">
        {getStackIconByName(stack) ? (
          <img
            src={getStackIconByName(stack)}
            alt={`${stack} icon`}
            className="w-6 h-6 rounded-[4px]"
          />
        ) : (
          <DefaultStackIcon />
        )}
      </div>
      {stack}
    </div>
  );
};

export { DefaultStackIcon };
export default SingleStackTag;
